var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(_vm._s(_vm.prop.title))]),_c('a',{staticClass:"section-header__more",on:{"click":function($event){return _vm.$router.push(_vm.prop.path)}}},[_vm._v(_vm._s(_vm.prop.button))])])
}
var staticRenderFns = []

export { render, staticRenderFns }